import SimpleSlider from './SimpleSlider.vue'

export default SimpleSlider
